import { CERelationshipAttributePermissionRuleBase } from './ce-relationship-attribute-permission-rule-base'


export class CERelationshipAttributePermissionRule extends CERelationshipAttributePermissionRuleBase {

}